// src/pages/Contatti.js
import { useState } from "react";
import "./Contatti.css";

const Contatti = () => {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    messaggio: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Messaggio inviato!\n\nNome: ${formData.nome}\nEmail: ${formData.email}\nMessaggio: ${formData.messaggio}`);
    setFormData({ nome: "", email: "", messaggio: "" });
  };

  const infoFittizi = {
    telefono: "+39 012 345 6789",
    email: "info@esempio.com",
    indirizzo: "Via Fittizia 123, 00100 Roma, Italia",
    orari: "Lun-Ven 9:00-18:00",
  };

  return (
    <div className="contatti-page">
      <h1>Contattaci</h1>
      <div className="contatti-container">
        <div className="contatti-info">
          <h2>Informazioni di contatto</h2>
          <p><strong>Telefono:</strong> {infoFittizi.telefono}</p>
          <p><strong>Email:</strong> {infoFittizi.email}</p>
          <p><strong>Indirizzo:</strong> {infoFittizi.indirizzo}</p>
          <p><strong>Orari:</strong> {infoFittizi.orari}</p>
          <div className="mappa-fittizia">
            <img src="./mappa.png" alt="Mappa fittizia" />
          </div>
        </div>

        <div className="contatti-form">
          <h2>Scrivici un messaggio</h2>
          <form onSubmit={handleSubmit}>
            <label htmlFor="nome">Nome:</label>
            <input
              id="nome"
              name="nome"
              type="text"
              value={formData.nome}
              onChange={handleChange}
              required
            />

            <label htmlFor="email">Email:</label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="messaggio">Messaggio:</label>
            <textarea
              id="messaggio"
              name="messaggio"
              value={formData.messaggio}
              onChange={handleChange}
              rows="5"
              required
            />

            <button type="submit">Invia Messaggio</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contatti;